import { FC } from "react";
import AppRouter from "./pages";

import "./App.scss";

const App: FC = () => {
  return (
    <div>
      <AppRouter />
    </div>
  );
};

export default App;
